/**
 * Allys Property Overview Component
 * 
 * Allys-themed wrapper for PropertyOverview - clean styling
 */

'use client';

import { PropertyOverview, type PropertyOverviewProps } from '@/components/properties';

export function AllysPropertyOverview(props: PropertyOverviewProps) {
  return (
    <div 
      className="relative font-inter"
    >
      <PropertyOverview {...props} className="" />
    </div>
  );
}
